export const overviewStats = {
  aiPostureScore: 74,
  aiPostureChange: 3,
  activeModels: { total: 12, high: 4, medium: 5, low: 3 },
  decisionRecords: { total: 47832, monthLabel: 'this month' },
  complianceGaps: { total: 7, critical: 3, medium: 4 },
};

export const decisionTrend = [
  { day: 'Mar 16', count: 1200 },
  { day: 'Mar 20', count: 1350 },
  { day: 'Mar 24', count: 1100 },
  { day: 'Mar 28', count: 1500 },
  { day: 'Apr 01', count: 1680 },
  { day: 'Apr 05', count: 1420 },
  { day: 'Apr 09', count: 1750 },
  { day: 'Apr 13', count: 1890 },
  { day: 'Apr 15', count: 1920 },
];

export const regulatoryReadiness = [
  { id: 'eu-ai', name: 'EU AI Act', progress: 68, status: 'warning', deadline: 'Annex III enforcement: August 2, 2026' },
  { id: 'iso-42001', name: 'ISO/IEC 42001', progress: 55, status: 'warning', deadline: 'Certification target: Q4 2026' },
  { id: 'nist-rmf', name: 'NIST AI RMF', progress: 71, status: 'compliant', deadline: 'Self-assessed' },
];

export const recentDecisionRecords = [
  { time: '14:32:07', model: 'GPT-4o', workflow: 'Contract Classification', riskTier: 'HIGH', outputType: 'Classification', sigStatus: 'Verified' },
  { time: '14:31:55', model: 'Claude Sonnet', workflow: 'Legal Document Drafting', riskTier: 'HIGH', outputType: 'Recommendation', sigStatus: 'Verified' },
  { time: '14:29:12', model: 'GPT-4o', workflow: 'Contract Classification', riskTier: 'HIGH', outputType: 'Classification', sigStatus: 'Verified' },
  { time: '14:28:44', model: 'Mistral 7B', workflow: 'Academy Recommendations', riskTier: 'MEDIUM', outputType: 'Ranking', sigStatus: 'Verified' },
  { time: '14:26:01', model: 'Internal Summarizer', workflow: 'Webcast Metadata', riskTier: 'LOW', outputType: 'Summary', sigStatus: 'Verified' },
  { time: '14:22:18', model: 'GPT-4o', workflow: 'Contract Classification', riskTier: 'HIGH', outputType: 'Classification', sigStatus: 'Verified' },
  { time: '14:19:33', model: 'Claude Sonnet', workflow: 'Legal Document Drafting', riskTier: 'HIGH', outputType: 'Recommendation', sigStatus: 'Verified' },
  { time: '14:15:47', model: 'GPT-4o Mini', workflow: 'Claims Document Processing', riskTier: 'MEDIUM', outputType: 'Summary', sigStatus: 'Warning' },
];

export const riskEvents = [
  { severity: 'critical', color: '#EF4444', title: 'GPT-4o Mini: Claims Document Processing', desc: 'Model unaudited, 0 compliance controls mapped', time: '2 hours ago', action: 'Investigate' },
  { severity: 'warning', color: '#F59E0B', title: 'Claude Sonnet: LegalDocs', desc: 'Data lineage gap detected in training pipeline', time: '1 day ago', action: 'Review' },
  { severity: 'info', color: '#3B82F6', title: 'EU AI Act Annex III obligations: Aug 2, 2026', desc: '7 control gaps remain open', time: 'Ongoing', action: 'View roadmap' },
];

export const aiModels = [
  {
    id: 'model-001',
    name: 'GPT-4o',
    provider: 'Azure OpenAI',
    version: '2025-11',
    workflow: 'Contract Classification',
    riskTier: 'HIGH',
    complianceStatus: 'Compliant',
    decisionRecords: 23441,
    lastAudited: '2 days ago',
    infraSource: 'Azure OpenAI · East US',
    infraType: 'cloud',
    deployment: 'Azure EU West, accessed via Meridian API Gateway',
    purpose: 'Automated contract classification using standardized taxonomy codes for incoming submissions',
    dataAccess: 'Meridian Contract Corpus, Classification Schema v9, applicant submission PDFs',
    owner: 'Contract Operations Division',
    riskFlags: [],
    euAiAct: { covered: 9, total: 9 },
    iso42001: { covered: 8, total: 8 },
    nistAiRmf: { covered: 10, total: 10 },
    assurance: { readiness: 89, evidence: 94, changeControl: 93, humanReview: 88, openGaps: 0 },
    dataLineage: [
      { name: 'Meridian Contract Corpus 2024', status: 'verified', type: 'Internal' },
      { name: 'IPC Classification Schema v9', status: 'verified', type: 'Internal' },
      { name: 'Applicant Submissions', status: 'verified', type: 'Session' },
      { name: 'Fine-tune Pipeline', status: 'verified', type: 'Internal' },
      { name: 'Azure OpenAI Endpoint', status: 'verified', type: 'External' },
      { name: 'Meridian API Gateway', status: 'verified', type: 'Internal' },
    ],
  },
  {
    id: 'model-002',
    name: 'Claude Sonnet 3.7',
    provider: 'Anthropic',
    version: '2025-10',
    workflow: 'Legal Document Drafting',
    riskTier: 'HIGH',
    complianceStatus: 'Gap Detected',
    decisionRecords: 8203,
    lastAudited: '5 days ago',
    infraSource: 'AWS Bedrock · eu-west-1',
    infraType: 'cloud',
    deployment: 'Azure EU West, accessed via Meridian API Gateway',
    purpose: 'Drafting recommendations for LegalDocs request portal',
    dataAccess: 'Internal legal corpus, staff identity, request metadata',
    owner: 'Information Technology Division',
    riskFlags: [
      { type: 'warning', text: 'Training data lineage unverified' },
      { type: 'critical', text: 'EU AI Act Article 13 transparency obligation — documentation incomplete' },
    ],
    euAiAct: { covered: 6, total: 9 },
    iso42001: { covered: 4, total: 8 },
    nistAiRmf: { covered: 7, total: 10 },
    assurance: { readiness: 62, evidence: 71, changeControl: 60, humanReview: 84, openGaps: 3 },
    dataLineage: [
      { name: 'External Legal Corpus', status: 'unverified', type: 'External' },
      { name: 'Fine-tune Pipeline', status: 'unverified', type: 'Internal' },
      { name: 'Anthropic Base Model', status: 'verified', type: 'External' },
      { name: 'Meridian API Gateway', status: 'verified', type: 'Internal' },
      { name: 'LegalDocs Application', status: 'verified', type: 'Internal' },
      { name: 'End User', status: 'verified', type: 'Session' },
    ],
  },
  {
    id: 'model-003',
    name: 'Mistral 7B (fine-tuned)',
    provider: 'Self-hosted',
    version: 'v2.1',
    workflow: 'Academy Training Recommendations',
    riskTier: 'MEDIUM',
    complianceStatus: 'Compliant',
    decisionRecords: 11204,
    lastAudited: '1 week ago',
    infraSource: 'GCP Vertex AI · europe-west1',
    infraType: 'cloud',
    deployment: 'On-Premise GPU Cluster, Zurich DC',
    purpose: 'Personalized training content recommendations for Meridian Academy students',
    dataAccess: 'Academy curriculum database, student interaction logs, course metadata',
    owner: 'Meridian Academy Division',
    riskFlags: [],
    euAiAct: { covered: 7, total: 7 },
    iso42001: { covered: 6, total: 6 },
    nistAiRmf: { covered: 8, total: 8 },
    assurance: { readiness: 78, evidence: 82, changeControl: 85, humanReview: 72, openGaps: 1 },
    dataLineage: [
      { name: 'Academy Curriculum DB', status: 'verified', type: 'Internal' },
      { name: 'Student Interaction Logs', status: 'verified', type: 'Internal' },
      { name: 'Course Metadata', status: 'verified', type: 'Internal' },
      { name: 'Mistral Fine-tuned Model', status: 'verified', type: 'Internal' },
    ],
  },
  {
    id: 'model-004',
    name: 'Internal Summarizer',
    provider: 'Meridian IT',
    version: 'v1.4',
    workflow: 'Webcast Metadata Tagging',
    riskTier: 'LOW',
    complianceStatus: 'Compliant',
    decisionRecords: 3917,
    lastAudited: '3 weeks ago',
    infraSource: 'On-premise · Geneva DC',
    infraType: 'server',
    deployment: 'Internal Kubernetes Cluster',
    purpose: 'Automated metadata extraction and tagging for Meridian webcast archives',
    dataAccess: 'Webcast transcript archive, metadata schema, tagging taxonomy',
    owner: 'Communications Division',
    riskFlags: [],
    euAiAct: { covered: 5, total: 5 },
    iso42001: { covered: 4, total: 4 },
    nistAiRmf: { covered: 6, total: 6 },
    assurance: { readiness: 91, evidence: 95, changeControl: 90, humanReview: 93, openGaps: 0 },
    dataLineage: [
      { name: 'Webcast Transcript Archive', status: 'verified', type: 'Internal' },
      { name: 'Metadata Schema', status: 'verified', type: 'Internal' },
      { name: 'Summarizer Model v1.4', status: 'verified', type: 'Internal' },
    ],
  },
  {
    id: 'model-005',
    name: 'GPT-4o Mini',
    provider: 'Azure OpenAI',
    version: '2025-09',
    workflow: 'Claims Document Processing',
    riskTier: 'MEDIUM',
    complianceStatus: 'Unaudited',
    decisionRecords: 1067,
    lastAudited: 'Never',
    infraSource: 'Azure OpenAI · West Europe',
    infraType: 'cloud',
    deployment: 'Azure EU West, accessed via Meridian API Gateway',
    purpose: 'Document summarization and extraction for claims arbitration case files',
    dataAccess: 'Claims case documents, arbitration metadata',
    owner: 'Claims Division',
    riskFlags: [
      { type: 'critical', text: 'Model has never been audited' },
      { type: 'critical', text: 'Zero compliance controls mapped' },
    ],
    euAiAct: { covered: 0, total: 8 },
    iso42001: { covered: 0, total: 8 },
    nistAiRmf: { covered: 0, total: 8 },
    assurance: { readiness: 0, evidence: 0, changeControl: 0, humanReview: 0, openGaps: 8 },
    dataLineage: [
      { name: 'Claims Case Documents', status: 'unverified', type: 'Internal' },
      { name: 'Azure OpenAI Endpoint', status: 'verified', type: 'External' },
      { name: 'Meridian API Gateway', status: 'verified', type: 'Internal' },
    ],
  },
];

export const ledgerRecords = [
  {
    id: 'DER-2026-047832', timestamp: 'Apr 15, 14:32:07', fullTimestamp: 'April 15, 2026 · 14:32:07 UTC',
    model: 'GPT-4o', workflow: 'Contract Classification', principal: 'contract-processor@meridian.global',
    outputType: 'Classification', riskTier: 'HIGH', controls: '9/9', sigStatus: 'verified',
    status: 'VERIFIED · COMPLIANT', signature: 'sha256:a3f9e2c1d8b7e4f690ab12cd34ef56gh78ij90kl',
    location: 'Meridian Global · Zurich Production',
    context: {
      workflow: 'Contract Classification Pipeline',
      model: 'GPT-4o (Azure OpenAI) · Version 2025-11',
      principal: 'contract-processor@meridian.global (service account)',
      reviewer: 'Contract Analyst ID CA-4471 (downstream)',
      input: 'Contract submission MG/2026/044821 — technical field: semiconductor manufacturing — 847 tokens — [REDACTED per data classification]',
      output: 'Classification → Category Code G01S 7/48, confidence 0.94',
    },
    dataAccess: [
      { source: 'Meridian Contract Corpus 2024', status: 'Verified', scope: 'Internal', access: 'Read' },
      { source: 'Classification Schema v9', status: 'Verified', scope: 'Internal', access: 'Read' },
      { source: 'Applicant submission PDF', status: 'Verified', scope: 'Session', access: 'Read' },
    ],
    regulatoryMapping: {
      euAiAct: { covered: 9, total: 9, controls: [
        { id: 'Art. 9', name: 'Risk Management System', status: 'pass' },
        { id: 'Art. 10', name: 'Data Governance', status: 'pass' },
        { id: 'Art. 11', name: 'Technical Documentation', status: 'pass' },
        { id: 'Art. 12', name: 'Record Keeping', status: 'pass' },
        { id: 'Art. 13', name: 'Transparency', status: 'pass' },
        { id: 'Art. 14', name: 'Human Oversight', status: 'pass' },
        { id: 'Art. 15', name: 'Accuracy & Robustness', status: 'pass' },
        { id: 'Art. 16', name: 'Provider Obligations', status: 'pass' },
        { id: 'Art. 17', name: 'Quality Management', status: 'pass' },
      ]},
      iso42001: { covered: 8, total: 8 },
      nistAiRmf: { covered: 10, total: 10 },
    },
    chainOfCustody: [
      { step: 'Model Invoked', time: '14:32:07.001', component: 'Azure OpenAI Gateway' },
      { step: 'Input Logged', time: '14:32:07.043', component: 'Apex Telemetry Collector' },
      { step: 'Output Generated', time: '14:32:07.891', component: 'GPT-4o Inference' },
      { step: 'Evidence Record Created', time: '14:32:07.923', component: 'Apex DER Engine' },
      { step: 'Cryptographic Signature Applied', time: '14:32:07.941', component: 'Apex Vault Service' },
      { step: 'Ledger Entry Written', time: '14:32:07.958', component: 'Immutable Ledger' },
      { step: 'Record Immutable', time: '14:32:07.961', component: 'Evidence Vault' },
    ],
  },
  {
    id: 'DER-2026-031204', timestamp: 'Apr 15, 11:14:22', fullTimestamp: 'April 15, 2026 · 11:14:22 UTC',
    model: 'GPT-4o', workflow: 'Contract Classification', principal: 'contract-processor@meridian.global',
    outputType: 'Classification', riskTier: 'HIGH', controls: '6/9', sigStatus: 'warning',
    status: 'EVIDENCE INCOMPLETE · INTEGRITY WARNING DETECTED', signature: 'sha256:e7c2f8a1d4b9g6h305kl12mn34op56qr78st90uv',
    location: 'Meridian Global · Zurich Production',
    isFailure: true,
    context: {
      workflow: 'Contract Classification Pipeline',
      model: 'GPT-4o (Azure OpenAI) · Version 2025-11',
      principal: 'contract-processor@meridian.global (service account)',
      reviewer: 'Contract Analyst ID CA-4471 (downstream)',
      input: 'Contract submission MG/2026/031204 — technical field: pharmaceutical compounds — 921 tokens — [REDACTED per data classification]',
      output: 'Classification → Category Code A61K 31/00, confidence 0.71',
    },
    dataAccess: [
      { source: 'Meridian Contract Corpus 2024', status: 'Verified', scope: 'Internal', access: 'Read' },
      { source: 'Classification Schema v9', status: 'Verified', scope: 'Internal', access: 'Read' },
      { source: 'External Legal Corpus', status: 'Unverified', scope: 'External', access: 'Read' },
    ],
    regulatoryMapping: {
      euAiAct: { covered: 7, total: 9, controls: [
        { id: 'Art. 9', name: 'Risk Management System', status: 'pass' },
        { id: 'Art. 10', name: 'Data Governance', status: 'fail' },
        { id: 'Art. 11', name: 'Technical Documentation', status: 'pass' },
        { id: 'Art. 12', name: 'Record Keeping', status: 'pass' },
        { id: 'Art. 13', name: 'Transparency', status: 'pass' },
        { id: 'Art. 14', name: 'Human Oversight', status: 'pass' },
        { id: 'Art. 15', name: 'Accuracy & Robustness', status: 'fail' },
        { id: 'Art. 16', name: 'Provider Obligations', status: 'pass' },
        { id: 'Art. 17', name: 'Quality Management', status: 'pass' },
      ]},
      iso42001: { covered: 6, total: 8 },
      nistAiRmf: { covered: 10, total: 10 },
    },
    chainOfCustody: [
      { step: 'Model Invoked', time: '11:14:22.001', component: 'Azure OpenAI Gateway' },
      { step: 'Input Logged', time: '11:14:22.038', component: 'Apex Telemetry Collector' },
      { step: 'Output Generated', time: '11:14:22.847', component: 'GPT-4o Inference' },
      { step: 'Evidence Record Created', time: '11:14:22.879', component: 'Apex DER Engine' },
      { step: 'Integrity Warning', time: '11:14:22.891', component: 'Hash Verification' },
      { step: 'Ledger Entry Written', time: '11:14:22.912', component: 'Immutable Ledger' },
      { step: 'Record Flagged', time: '11:14:22.920', component: 'Evidence Vault' },
    ],
  },
  {
    id: 'DER-2026-047831', timestamp: 'Apr 15, 14:31:55', fullTimestamp: 'April 15, 2026 · 14:31:55 UTC',
    model: 'Claude Sonnet', workflow: 'Legal Doc Drafting', principal: 'legaldocs-agent@meridian.global',
    outputType: 'Recommendation', riskTier: 'HIGH', controls: '6/9', sigStatus: 'warning',
    status: 'VERIFIED · GAP DETECTED', signature: 'sha256:b4g0f3d2e9c8a5h701bc23de45fg67hi89jk01lm',
    location: 'Meridian Global · Zurich Production',
    context: {
      workflow: 'Legal Document Drafting Pipeline',
      model: 'Claude Sonnet 3.7 (Anthropic) · Version 2025-10',
      principal: 'legaldocs-agent@meridian.global (service account)',
      reviewer: 'Legal Officer ID LO-2287 (downstream)',
      input: 'Legal request LR-2026-08841 — domain: trademark dispute — 1,203 tokens — [REDACTED]',
      output: 'Recommendation → Draft response with 3 precedent citations, confidence 0.87',
    },
    dataAccess: [
      { source: 'Internal Legal Corpus', status: 'Verified', scope: 'Internal', access: 'Read' },
      { source: 'Staff Identity Service', status: 'Verified', scope: 'Internal', access: 'Read' },
      { source: 'Request Metadata', status: 'Verified', scope: 'Session', access: 'Read' },
    ],
    regulatoryMapping: {
      euAiAct: { covered: 6, total: 9, controls: [
        { id: 'Art. 9', name: 'Risk Management System', status: 'pass' },
        { id: 'Art. 10', name: 'Data Governance', status: 'pass' },
        { id: 'Art. 11', name: 'Technical Documentation', status: 'pass' },
        { id: 'Art. 12', name: 'Record Keeping', status: 'pass' },
        { id: 'Art. 13', name: 'Transparency', status: 'fail' },
        { id: 'Art. 14', name: 'Human Oversight', status: 'pass' },
        { id: 'Art. 15', name: 'Accuracy & Robustness', status: 'fail' },
        { id: 'Art. 16', name: 'Provider Obligations', status: 'pass' },
        { id: 'Art. 17', name: 'Quality Management', status: 'fail' },
      ]},
      iso42001: { covered: 4, total: 8 },
      nistAiRmf: { covered: 7, total: 10 },
    },
    chainOfCustody: [
      { step: 'Model Invoked', time: '14:31:55.001', component: 'Meridian API Gateway' },
      { step: 'Input Logged', time: '14:31:55.004', component: 'Apex Intercept Agent' },
      { step: 'Output Generated', time: '14:31:56.203', component: 'Anthropic Claude Sonnet' },
      { step: 'Evidence Record Created', time: '14:31:56.210', component: 'Apex AI Trust Engine' },
      { step: 'Cryptographic Signature Applied', time: '14:31:56.214', component: 'Apex HSM Module' },
      { step: 'Ledger Entry Written', time: '14:31:56.220', component: 'Apex Decision Ledger' },
      { step: 'Record Immutable', time: '14:31:56.222', component: 'Apex Tamper-Evident Store' },
    ],
  },
  {
    id: 'DER-2026-047830', timestamp: 'Apr 15, 14:29:12', fullTimestamp: 'April 15, 2026 · 14:29:12 UTC',
    model: 'GPT-4o', workflow: 'Contract Classification', principal: 'contract-processor@meridian.global',
    outputType: 'Classification', riskTier: 'HIGH', controls: '9/9', sigStatus: 'verified',
    status: 'VERIFIED · COMPLIANT', signature: 'sha256:c5h1g4e3f0d9b6i802cd34ef56gh78ij90kl12mn',
    location: 'Meridian Global · Zurich Production',
  },
  {
    id: 'DER-2026-047821', timestamp: 'Apr 15, 14:15:33', fullTimestamp: 'April 15, 2026 · 14:15:33 UTC',
    model: 'Mistral 7B', workflow: 'Academy Recs', principal: 'academy-svc@meridian.global',
    outputType: 'Ranking', riskTier: 'MEDIUM', controls: '8/8', sigStatus: 'verified',
    status: 'VERIFIED · COMPLIANT', signature: 'sha256:d6i2h5f4g1e0c7j903de45fg67hi89jk01lm23no',
    location: 'Meridian Global · Zurich Production',
  },
  {
    id: 'DER-2026-047809', timestamp: 'Apr 15, 13:58:41', fullTimestamp: 'April 15, 2026 · 13:58:41 UTC',
    model: 'GPT-4o Mini', workflow: 'Claims Docs', principal: 'amcdoc-svc@meridian.global',
    outputType: 'Summary', riskTier: 'MEDIUM', controls: '0/8', sigStatus: 'critical',
    status: 'UNAUDITED · NON-COMPLIANT', signature: 'sha256:e7j3i6g5h2f1d8k004ef56gh78ij90kl12mn34op',
    location: 'Meridian Global · Zurich Production',
  },
  {
    id: 'DER-2026-047798', timestamp: 'Apr 15, 13:42:19', fullTimestamp: 'April 15, 2026 · 13:42:19 UTC',
    model: 'Internal Summarizer', workflow: 'Webcast Metadata', principal: 'webcast-svc@meridian.global',
    outputType: 'Summary', riskTier: 'LOW', controls: '5/5', sigStatus: 'verified',
    status: 'VERIFIED · COMPLIANT', signature: 'sha256:f8k4j7h6i3g2e9l105fg67hi89jk01lm23no45pq',
    location: 'Meridian Global · Zurich Production',
  },
  {
    id: 'DER-2026-047785', timestamp: 'Apr 15, 13:28:07', fullTimestamp: 'April 15, 2026 · 13:28:07 UTC',
    model: 'GPT-4o', workflow: 'Contract Classification', principal: 'contract-processor@meridian.global',
    outputType: 'Classification', riskTier: 'HIGH', controls: '9/9', sigStatus: 'verified',
    status: 'VERIFIED · COMPLIANT', signature: 'sha256:g9l5k8i7j4h3f0m206gh78ij90kl12mn34op56qr',
    location: 'Meridian Global · Zurich Production',
  },
  {
    id: 'DER-2026-047772', timestamp: 'Apr 15, 13:14:52', fullTimestamp: 'April 15, 2026 · 13:14:52 UTC',
    model: 'Claude Sonnet', workflow: 'Legal Doc Drafting', principal: 'legaldocs-agent@meridian.global',
    outputType: 'Recommendation', riskTier: 'HIGH', controls: '6/9', sigStatus: 'warning',
    status: 'VERIFIED · GAP DETECTED', signature: 'sha256:h0m6l9j8k5i4g1n307hi89jk01lm23no45pq67rs',
    location: 'Meridian Global · Zurich Production',
  },
  {
    id: 'DER-2026-028847', timestamp: 'Apr 8, 10:05:33', fullTimestamp: 'April 8, 2026 · 10:05:33 UTC',
    model: 'Claude Sonnet 3.7', workflow: 'Legal Document Drafting', principal: 'legaldocs-agent@meridian.global',
    outputType: 'Recommendation', riskTier: 'MEDIUM', controls: '9/9', sigStatus: 'closed',
    status: 'EVIDENCE COMPLETE · CONTROL RE-VERIFIED · EXCEPTION CLOSED', signature: 'sha256:r4t7v2x9y1a3b5c8d0e6f',
    location: 'Meridian Global · Zurich Production',
    isResolved: true,
    context: {
      workflow: 'Legal Document Drafting Pipeline',
      model: 'Claude Sonnet 3.7 (AWS Bedrock) · eu-west-1',
      principal: 'legaldocs-agent@meridian.global (service account)',
      reviewer: 'Legal Analyst ID LA-2287 (downstream)',
      input: 'Legal document review request #MG/2026/028847 — employment contract amendment — 1,204 tokens — [REDACTED]',
      output: 'Recommendation → Clause revision suggested, confidence 0.91',
    },
    dataAccess: [
      { source: 'Internal Legal Corpus', status: 'Verified', scope: 'Internal', access: 'Read' },
      { source: 'Staff Identity Service', status: 'Verified', scope: 'Internal', access: 'Read' },
      { source: 'External Legal Corpus', status: 'Verified', scope: 'External', access: 'Read' },
    ],
    regulatoryMapping: {
      euAiAct: { covered: 9, total: 9, controls: [
        { id: 'Art. 9', name: 'Risk Management System', status: 'pass' },
        { id: 'Art. 10', name: 'Data Governance', status: 'pass' },
        { id: 'Art. 11', name: 'Technical Documentation', status: 'pass' },
        { id: 'Art. 12', name: 'Record Keeping', status: 'pass' },
        { id: 'Art. 13', name: 'Transparency', status: 'pass' },
        { id: 'Art. 14', name: 'Human Oversight', status: 'pass' },
        { id: 'Art. 15', name: 'Accuracy & Robustness', status: 'pass' },
        { id: 'Art. 16', name: 'Provider Obligations', status: 'pass' },
        { id: 'Art. 17', name: 'Quality Management', status: 'pass' },
      ]},
      iso42001: { covered: 8, total: 8 },
      nistAiRmf: { covered: 10, total: 10 },
    },
    chainOfCustody: [
      { step: 'Model Invoked', time: '10:05:33.001', component: 'AWS Bedrock Gateway' },
      { step: 'Input Logged', time: '10:05:33.045', component: 'Apex Telemetry Collector' },
      { step: 'Output Generated', time: '10:05:34.102', component: 'Claude Sonnet 3.7' },
      { step: 'Evidence Record Created', time: '10:05:34.138', component: 'Apex DER Engine' },
      { step: 'Signature Applied', time: '10:05:34.152', component: 'Cryptographic Signer' },
      { step: 'Sealed in Vault', time: '10:05:34.170', component: 'Evidence Vault' },
    ],
  },
];

export const complianceGaps = [
  { controlId: 'EU-AI-13.1', framework: 'EU AI Act', description: 'Transparency documentation incomplete for Legal Document Drafting model', affectedModels: 'Claude Sonnet 3.7', severity: 'critical', owner: 'Unassigned', dueDate: 'Jun 15, 2026', status: 'Open' },
  { controlId: 'EU-AI-15.2', framework: 'EU AI Act', description: 'Accuracy validation not performed for Claims Document Processing', affectedModels: 'GPT-4o Mini', severity: 'critical', owner: 'Unassigned', dueDate: 'May 30, 2026', status: 'Open' },
  { controlId: 'EU-AI-17.1', framework: 'EU AI Act', description: 'Quality management system not established for LegalDocs workflow', affectedModels: 'Claude Sonnet 3.7', severity: 'critical', owner: 'Unassigned', dueDate: 'Jul 01, 2026', status: 'Open' },
  { controlId: 'ISO-42001-6.1', framework: 'ISO/IEC 42001', description: 'Risk assessment incomplete for 2 AI systems', affectedModels: 'Claude Sonnet 3.7, GPT-4o Mini', severity: 'medium', owner: 'J. Mueller', dueDate: 'Aug 15, 2026', status: 'In Progress' },
  { controlId: 'ISO-42001-7.2', framework: 'ISO/IEC 42001', description: 'Training data governance procedures not documented', affectedModels: 'Claude Sonnet 3.7', severity: 'medium', owner: 'S. Chen', dueDate: 'Sep 01, 2026', status: 'In Progress' },
  { controlId: 'NIST-MAP-1.5', framework: 'NIST AI RMF', description: 'Impact assessment not completed for Academy Recommendations', affectedModels: 'Mistral 7B', severity: 'medium', owner: 'K. Patel', dueDate: 'Jul 30, 2026', status: 'In Progress' },
  { controlId: 'NIST-GOV-2.1', framework: 'NIST AI RMF', description: 'AI governance roles not formally documented for Claims division', affectedModels: 'GPT-4o Mini', severity: 'medium', owner: 'Unassigned', dueDate: 'Aug 30, 2026', status: 'Open' },
];

export const socAlerts = [
  {
    id: 'CS-2026-00441', source: 'CrowdStrike', severity: 'CRITICAL', type: 'Privilege Escalation',
    asset: 'WIN-DC-MG-01', status: 'Triaged', decision: 'Escalate to IR', time: '08:14',
    detail: {
      reasoning: [
        'Step 1: Asset classification — WIN-DC-MG-01 is a domain controller, tier-0 asset.',
        'Step 2: Behavior analysis — privilege escalation via token impersonation, technique T1134.',
        'Step 3: Precedent check — 0 similar alerts in last 90 days.',
        'Step 4: Risk scoring — Critical. Recommendation: Escalate to IR immediately.',
      ],
      analyst: 'SOC Analyst L2 · Analyst ID SA-0092',
      action: 'Confirmed escalation to Incident Response team',
      timeline: [
        { time: '08:14:01', event: 'Alert received from CrowdStrike NG-SIEM' },
        { time: '08:14:02', event: 'Apex SOC AI reasoning chain initiated' },
        { time: '08:14:04', event: 'AI recommendation: Escalate to IR' },
        { time: '08:14:31', event: 'Analyst SA-0092 reviewed and confirmed' },
        { time: '08:14:35', event: 'Decision record created and signed' },
      ],
    },
  },
  {
    id: 'CS-2026-00440', source: 'CrowdStrike', severity: 'MEDIUM', type: 'Lateral Movement',
    asset: 'SRV-FILE-07', status: 'Triaged', decision: 'False Positive', time: '07:58',
    detail: {
      reasoning: [
        'Step 1: Asset classification — SRV-FILE-07 is a file server, tier-2 asset.',
        'Step 2: Behavior analysis — SMB lateral movement detected, T1021.002.',
        'Step 3: Context check — scheduled backup job running at this time.',
        'Step 4: Risk scoring — Low. Recommendation: Mark as False Positive.',
      ],
      analyst: 'SOC Analyst L1 · Analyst ID SA-0115',
      action: 'Confirmed false positive — scheduled backup activity',
    },
  },
  {
    id: 'CS-2026-00439', source: 'CrowdStrike', severity: 'MEDIUM', type: 'Suspicious Script',
    asset: 'LAPTOP-PE4471', status: 'Pending', decision: null, time: '07:45',
  },
  {
    id: 'CS-2026-00438', source: 'CrowdStrike', severity: 'LOW', type: 'Recon Detected',
    asset: 'DMZ-WEB-02', status: 'Triaged', decision: 'Monitor', time: '07:31',
  },
  {
    id: 'CS-2026-00437', source: 'CrowdStrike', severity: 'MEDIUM', type: 'Anomalous Login',
    asset: 'SRV-APP-03', status: 'Triaged', decision: 'Investigate', time: '07:12',
  },
  {
    id: 'CS-2026-00436', source: 'CrowdStrike', severity: 'LOW', type: 'Policy Violation',
    asset: 'LAPTOP-IT2201', status: 'Triaged', decision: 'Accepted Risk', time: '06:54',
  },
];

export const cloudAccounts = [
  { name: 'mglobal-prod-core', env: 'Production', score: 91, scoreStatus: 'good', driftEvents: 2, critical: 0, lastScan: '4 min' },
  { name: 'mglobal-prod-ai', env: 'Production', score: 73, scoreStatus: 'warning', driftEvents: 8, critical: 2, lastScan: '4 min' },
  { name: 'mglobal-dev-sandbox', env: 'Development', score: 84, scoreStatus: 'good', driftEvents: 5, critical: 0, lastScan: '4 min' },
  { name: 'mglobal-staging', env: 'Staging', score: 88, scoreStatus: 'good', driftEvents: 4, critical: 1, lastScan: '4 min' },
  { name: 'mglobal-legacy-apps', env: 'Production', score: 61, scoreStatus: 'critical', driftEvents: 4, critical: 0, lastScan: '4 min' },
];

export const driftEvents = [
  { id: 'DRF-001', service: 'S3', description: 'S3 bucket public access enabled on mglobal-prod-ai-training-data', account: 'mglobal-prod-ai', severity: 'CRITICAL', time: '12 min ago' },
  { id: 'DRF-002', service: 'EC2', description: 'Security group 0.0.0.0/0 ingress on port 22 added to sg-ai-inference', account: 'mglobal-prod-ai', severity: 'CRITICAL', time: '28 min ago' },
  { id: 'DRF-003', service: 'IAM', description: 'IAM policy with wildcard permissions attached to role ai-pipeline-executor', account: 'mglobal-staging', severity: 'HIGH', time: '1 hour ago' },
  { id: 'DRF-004', service: 'CloudTrail', description: 'CloudTrail logging disabled in eu-west-1 region', account: 'mglobal-legacy-apps', severity: 'HIGH', time: '3 hours ago' },
  { id: 'DRF-005', service: 'KMS', description: 'KMS key rotation disabled for alias/mglobal-data-encryption', account: 'mglobal-prod-core', severity: 'MEDIUM', time: '6 hours ago' },
];

export const notifications = [
  { id: 1, type: 'critical', title: 'GPT-4o Mini: Claims unaudited', desc: '0 compliance controls mapped', time: '2h ago' },
  { id: 2, type: 'warning', title: 'S3 bucket public access enabled', desc: 'mglobal-prod-ai-training-data', time: '12m ago' },
  { id: 3, type: 'info', title: 'EU AI Act Annex III: Aug 2, 2026', desc: '7 compliance control gaps remaining', time: 'Ongoing' },
];

export const euAiActControls = [
  { id: 'Art. 9', name: 'Risk Management System' },
  { id: 'Art. 10', name: 'Data Governance' },
  { id: 'Art. 11', name: 'Technical Documentation' },
  { id: 'Art. 12', name: 'Record Keeping' },
  { id: 'Art. 13', name: 'Transparency' },
  { id: 'Art. 14', name: 'Human Oversight' },
  { id: 'Art. 15', name: 'Accuracy & Robustness' },
  { id: 'Art. 16', name: 'Provider Obligations' },
  { id: 'Art. 17', name: 'Quality Management' },
];

/* ═══════════════════════════════════════════════════════
   PROOF CHAIN ENTITIES
   ═══════════════════════════════════════════════════════ */

export const classificationEvidenceRecords = [
  {
    id: 'CER-2026-001', version: '3.2', proofGrade: 'AUDIT-GRADE', reconstructionMethod: 'SDK Capture + Legal Review',
    modelId: 'model-001', modelName: 'GPT-4o', workflow: 'Contract Classification',
    classification: 'HIGH-RISK', annexCategory: 'Category 5(b) — AI in access to services',
    orgRole: 'DEPLOYER', confirmed: true, jurisdiction: 'EU, Switzerland, Global',
    humanOversight: 'MANDATORY (Art. 14)', docRequired: 'Annex IV Technical File', docCurrent: true,
    approvedBy: 'J. Mueller, Legal', effectiveDate: 'Feb 14, 2026', effectiveEnd: 'Present',
    nextReview: 'Aug 14, 2026', lastReview: 'Feb 14, 2026',
    versionHistory: [
      { v: 'v1.0', date: 'Nov 2025', summary: 'Initial classification' },
      { v: 'v2.0', date: 'Dec 2025', summary: 'Annex III category confirmed' },
      { v: 'v3.0', date: 'Jan 2026', summary: 'Deployer role confirmed after legal review' },
      { v: 'v3.2', date: 'Feb 2026', summary: 'Documentation requirements updated for Art. 11' },
    ],
    driftAlert: null,
  },
  {
    id: 'CER-2026-002', version: '2.1', proofGrade: 'OPERATIONS-GRADE', reconstructionMethod: 'Legal Review + Native',
    modelId: 'model-002', modelName: 'Claude Sonnet 3.7', workflow: 'Legal Document Drafting',
    classification: 'HIGH-RISK', annexCategory: 'Category 5(b) — AI in access to services',
    orgRole: 'DEPLOYER', confirmed: true, jurisdiction: 'EU, Switzerland, Global',
    humanOversight: 'MANDATORY (Art. 14)', docRequired: 'Annex IV Technical File', docCurrent: false,
    approvedBy: 'K. Patel, Legal', effectiveDate: 'Jan 15, 2026', effectiveEnd: 'Present',
    nextReview: 'Jul 15, 2026', lastReview: 'Jan 15, 2026',
    versionHistory: [
      { v: 'v1.0', date: 'Nov 2025', summary: 'Initial classification' },
      { v: 'v2.0', date: 'Jan 2026', summary: 'Deployer role confirmed' },
      { v: 'v2.1', date: 'Jan 2026', summary: 'Fine-tuning activity noted' },
    ],
    driftAlert: 'Fine-tuning activity detected since last classification. Legal status may warrant review — Deployer obligations may have expanded. Legal review recommended before August 2, 2026.',
  },
  {
    id: 'CER-NONE', version: null, proofGrade: 'UNAUDITED', reconstructionMethod: 'None',
    modelId: 'model-005', modelName: 'doc-processor-03', workflow: 'Claims Document Processing',
    classification: null, annexCategory: null, orgRole: null, confirmed: false,
    jurisdiction: null, humanOversight: null, docRequired: null, docCurrent: false,
    approvedBy: null, effectiveDate: null, effectiveEnd: null,
    nextReview: null, lastReview: null, versionHistory: [],
    driftAlert: 'No Classification Evidence Record. This system is generating decisions without governance proof.',
  },
];

export const controlStateSnapshots = [
  {
    id: 'CSS-2026-047832', derId: 'DER-2026-047832', proofGrade: 'AUDIT-GRADE',
    reconstructionMethod: 'SDK Capture + ServiceNow GRC',
    effectiveAt: 'Apr 15, 2026 · 14:32:07 UTC', evidenceCoverage: 94,
    fields: [
      { label: 'Policy Version', value: 'v2.3-ldrs', status: 'ok', note: 'Current at invocation' },
      { label: 'Guardrail Version', value: 'v1.8', status: 'ok', note: 'No changes in 21 days' },
      { label: 'Model Approval State', value: 'GPT-4o 2025-11', status: 'ok', note: 'Approved' },
      { label: 'Human Review Policy', value: 'Mandatory · EU AI Act Art. 14', status: 'ok', note: 'Met' },
      { label: 'Data Source Allowlist', value: 'v4.1', status: 'ok', note: 'All 3 sources listed' },
      { label: 'Active Exceptions', value: 'None', status: 'ok', note: '' },
      { label: 'Evidence Coverage', value: '94%', status: 'ok', note: 'Above 80% threshold' },
    ],
    summary: 'This decision was made under a fully compliant control environment at decision time. No control gaps were active at invocation.',
    gap: null,
  },
  {
    id: 'CSS-2026-031204', derId: 'DER-2026-031204', proofGrade: 'AUDIT-GRADE',
    reconstructionMethod: 'SDK Capture',
    effectiveAt: 'Apr 15, 2026 · 11:14:22 UTC', evidenceCoverage: 71,
    fields: [
      { label: 'Policy Version', value: 'v2.1-ldrs', status: 'warn', note: 'Modified 2 hours prior' },
      { label: 'Guardrail Version', value: 'v1.8', status: 'ok', note: 'Current' },
      { label: 'Model Approval State', value: 'GPT-4o 2025-11', status: 'ok', note: 'Approved' },
      { label: 'Human Review Policy', value: 'Mandatory', status: 'ok', note: 'Met' },
      { label: 'Data Source Allowlist', value: 'v4.1', status: 'warn', note: 'External Legal Corpus NOT listed' },
      { label: 'Active Exceptions', value: 'None', status: 'warn', note: 'No exception covered this gap' },
      { label: 'Evidence Coverage', value: '71%', status: 'warn', note: 'Below recommended threshold' },
    ],
    summary: null,
    gap: 'This decision was made while a data source outside the approved allowlist was active at decision time. No exception covered this gap. This is the root cause of the current integrity warning.',
  },
  {
    id: 'CSS-2026-028847', derId: 'DER-2026-028847', proofGrade: 'AUDIT-GRADE',
    reconstructionMethod: 'SDK Capture + ServiceNow GRC',
    effectiveAt: 'Apr 8, 2026 · 10:05:33 UTC', evidenceCoverage: 94,
    fields: [
      { label: 'Policy Version', value: 'v2.3-ldrs', status: 'ok', note: 'Current at invocation' },
      { label: 'Guardrail Version', value: 'v1.8', status: 'ok', note: 'Current' },
      { label: 'Model Approval State', value: 'Claude Sonnet 3.7', status: 'ok', note: 'Approved' },
      { label: 'Human Review Policy', value: 'Mandatory', status: 'ok', note: 'Met' },
      { label: 'Data Source Allowlist', value: 'v4.2', status: 'ok', note: 'All sources re-verified' },
      { label: 'Active Exceptions', value: 'EXC-2026-0038 (closed)', status: 'ok', note: 'Remediated' },
      { label: 'Evidence Coverage', value: '94%', status: 'ok', note: 'Restored above threshold' },
    ],
    summary: 'This decision was made under a restored compliant control environment. Control gap was identified and remediated. Control state restored to compliant on Apr 19, 2026.',
    gap: null,
  },
];

export const oversightEvidenceRecords = [
  {
    id: 'OER-2026-047832', derId: 'DER-2026-047832', proofGrade: 'AUDIT-GRADE',
    reconstructionMethod: 'SDK Capture + Entra ID + Workday',
    requirement: 'EU AI Act Art. 14 · Mandatory Review',
    reviewer: 'Contract Analyst ID CA-4471',
    identityVerified: true, identitySource: 'Entra ID confirmed · MFA active at review time',
    reviewerRole: 'Contract Analyst · Authorized for HIGH-RISK workflows',
    duration: '4 minutes 12 seconds', durationSeconds: 252,
    complexityScore: 'HIGH', complexityDetail: '1,247 tokens · 3 data sources · regulated workflow',
    durationVsComplexity: 'ok', durationNote: 'Consistent — sufficient for output length and type',
    checklistCompleted: '5/5', checklistOk: true,
    changesMade: 'None — accepted as generated',
    rubberStampRisk: 'LOW', rubberStampNote: 'Duration and checklist consistent with complexity',
    aiLiteracy: true, aiLiteracyDetail: 'Certified · CA-4471 · Expires Dec 2026',
    escalation: null,
    timestamp: 'Apr 15, 2026 · 14:37:44 UTC',
  },
  {
    id: 'OER-2026-031105', derId: 'DER-2026-031204', proofGrade: 'OPERATIONS-GRADE',
    reconstructionMethod: 'SDK Capture + Entra ID',
    requirement: 'EU AI Act Art. 14 · Mandatory Review',
    reviewer: 'Legal Analyst ID LA-0912',
    identityVerified: true, identitySource: 'Entra ID confirmed',
    reviewerRole: 'Legal Analyst · Authorized for HIGH-RISK workflows',
    duration: '23 seconds', durationSeconds: 23,
    complexityScore: 'HIGH', complexityDetail: '1,891 tokens · 5 data sources · regulated workflow',
    durationVsComplexity: 'warn', durationNote: 'Inconsistent — duration short relative to output type',
    checklistCompleted: '2/5', checklistOk: false,
    changesMade: 'None',
    rubberStampRisk: 'HIGH', rubberStampNote: 'Review duration inconsistent with complexity',
    aiLiteracy: true, aiLiteracyDetail: 'Certified · LA-0912 · Expires Sep 2026',
    escalation: 'Oversight evidence signals are below the defensible threshold for this workflow. Supplementary attestation may be required for external audit. Escalated to: Head of Compliance for review.',
    timestamp: 'Apr 15, 2026 · 11:19:03 UTC',
  },
  {
    id: 'OER-2026-028847', derId: 'DER-2026-028847', proofGrade: 'AUDIT-GRADE',
    reconstructionMethod: 'SDK Capture + Entra ID + Workday',
    requirement: 'EU AI Act Art. 14 · Mandatory Review',
    reviewer: 'Legal Analyst ID LA-2287',
    identityVerified: true, identitySource: 'Entra ID confirmed · MFA active at review time',
    reviewerRole: 'Legal Analyst · Authorized for HIGH-RISK workflows',
    duration: '6 minutes 44 seconds', durationSeconds: 404,
    complexityScore: 'HIGH', complexityDetail: '1,540 tokens · 3 data sources · regulated workflow',
    durationVsComplexity: 'ok', durationNote: 'Consistent — thorough review evidenced',
    checklistCompleted: '5/5', checklistOk: true,
    changesMade: 'Minor edits to 2 citations',
    rubberStampRisk: 'LOW', rubberStampNote: 'Duration, checklist, and edits consistent with complexity',
    aiLiteracy: true, aiLiteracyDetail: 'Certified · LA-2287 · Expires Dec 2026',
    escalation: null,
    timestamp: 'Apr 8, 2026 · 10:12:17 UTC',
  },
];

export const proofChainLinks = {
  clean: {
    scenario: 'Legal Document Drafting · Clean Decision',
    derId: 'DER-2026-047832',
    nodes: [
      { type: 'CER', id: 'CER-2026-001', grade: 'AUDIT-GRADE', method: 'SDK Capture + Legal Review', line1: 'HIGH-RISK · Annex III · Deployer', line2: 'Approved: J. Mueller · Feb 14, 2026', line3: 'Effective: Feb 14, 2026 → Present', status: 'ok' },
      { type: 'CSS', id: 'CSS-2026-047832', grade: 'AUDIT-GRADE', method: 'SDK Capture + ServiceNow GRC', line1: '94% evidence coverage', line2: 'All controls active · No exceptions', line3: 'Policy v2.3 · Apr 15, 2026 · 14:32:07', status: 'ok' },
      { type: 'DER', id: 'DER-2026-047832', grade: 'AUDIT-GRADE', method: 'SDK Capture + Collibra', line1: 'Contract Classification · GPT-4o', line2: 'Confidence: 0.94 · 9/9 controls', line3: 'Apr 15, 2026 · 14:32:07 UTC', status: 'ok' },
      { type: 'OER', id: 'OER-2026-047832', grade: 'AUDIT-GRADE', method: 'SDK Capture + Entra ID + Workday', line1: 'CA-4471 · 4m 12s · Defensible signals', line2: 'Low rubber-stamp risk', line3: 'Apr 15, 2026 · 14:37:44 UTC', status: 'ok' },
      { type: 'PKG', id: 'PKG-2026-Q1-003', grade: 'AUDIT-GRADE', method: 'Assembled', line1: 'EU AI Act + SOC 2', line2: 'Generated: Apr 15, 2026', line3: 'Complete · 47,832 records', status: 'ok' },
    ],
    links: [
      { hash: 'sha256:a4f2c8e7b1d4f5a6', ts: 'Apr 15 · 14:32:07', verified: true },
      { hash: 'sha256:9f3a2c8e7b1d4f5a', ts: 'Apr 15 · 14:32:07', verified: true },
      { hash: 'sha256:c7e1f9a3b5d8e2c4', ts: 'Apr 15 · 14:37:44', verified: true },
      { hash: 'sha256:d2b4e6f8a0c3d5e7', ts: 'Apr 15 · 14:38:01', verified: true },
    ],
  },
  broken: {
    scenario: 'Failure Investigation · Integrity Warning',
    derId: 'DER-2026-031204',
    nodes: [
      { type: 'CER', id: 'CER-2026-001', grade: 'AUDIT-GRADE', method: 'SDK Capture + Legal Review', line1: 'HIGH-RISK · Annex III · Deployer', line2: 'Approved: J. Mueller · Feb 14, 2026', line3: 'Effective: Feb 14, 2026 → Present', status: 'ok' },
      { type: 'CSS', id: 'CSS-2026-031204', grade: 'AUDIT-GRADE', method: 'SDK Capture', line1: '71% evidence coverage', line2: 'CONTROL GAP AT DECISION TIME', line3: 'Policy v2.1 · Apr 15, 2026 · 11:14:22', status: 'broken', breakReason: 'Data source outside approved allowlist active at decision time.\nNo exception approved. Evidence coverage 71% — below threshold.', owner: 'Head of Compliance · J. Mueller', action: 'Approve exception retroactively or flag decisions for re-review', eta: '2–4 hours' },
      { type: 'DER', id: 'DER-2026-031204', grade: 'AUDIT-GRADE', method: 'SDK Capture', line1: 'Contract Classification · GPT-4o', line2: 'Confidence: 0.71 · 6/9 controls', line3: 'Apr 15, 2026 · 11:14:22 UTC', status: 'ok' },
      { type: 'OER', id: 'OER-2026-031105', grade: 'OPERATIONS-GRADE', method: 'SDK Capture + Entra ID', line1: 'LA-0912 · 23s · Weak signals', line2: 'High rubber-stamp risk', line3: 'Apr 15, 2026 · 11:19:03 UTC', status: 'warn' },
      { type: 'PKG', id: 'PKG-2026-Q1-004', grade: 'OPERATIONS-GRADE', method: 'Pending', line1: 'EU AI Act + SOC 2', line2: 'Incomplete — awaiting remediation', line3: 'Blocked on CSS gap', status: 'pending' },
    ],
    links: [
      { hash: 'sha256:a4f2c8e7b1d4f5a6', ts: 'Apr 15 · 11:14:22', verified: true },
      { hash: 'sha256:CHAIN_BREAK', ts: 'Apr 15 · 11:14:22', verified: false, breakMsg: 'Control gap at Apr 15 · 11:14:22\nRemediation required' },
      { hash: 'sha256:e7c2f8a1d4b9g6h3', ts: 'Apr 15 · 11:19:03', verified: true },
      { hash: 'sha256:pending', ts: 'Pending', verified: false },
    ],
  },
};

export const integrationConnections = [
  { name: 'Microsoft Sentinel', tier: 'Tier 1', status: 'active', lastSync: '2 min ago', records: 847, enriches: 'CSS security context', proves: 'No active security incident was correlated with this AI decision at decision time.' },
  { name: 'ServiceNow GRC', tier: 'Tier 2', status: 'active', lastSync: '15 min ago', records: 0, enriches: 'All CSSs', proves: 'The policy version active at decision time was formally approved through change management.' },
  { name: 'Microsoft Entra ID', tier: 'Tier 2', status: 'active', lastSync: 'Real-time', records: 47, enriches: 'All OERs', proves: 'The reviewer was who they claimed to be. MFA was active. Their session was legitimate.' },
  { name: 'Collibra', tier: 'Tier 2', status: 'active', lastSync: '1 hour ago', records: 12, enriches: 'OERs + DER sources', proves: 'Every data source used in this decision had current license and consent basis at decision time.' },
  { name: 'OpenAI / Azure OpenAI', tier: 'Tier 1', status: 'active', lastSync: 'Real-time', records: 14832, enriches: 'DER model_id, version, token_count', proves: 'The model invoked was the approved version. Token count and model hash match the DER.' },
  { name: 'Anthropic Claude / AWS Bedrock', tier: 'Tier 1', status: 'active', lastSync: 'Real-time', records: 8203, enriches: 'DER via CloudTrail', proves: 'AWS CloudTrail confirms this Bedrock invocation occurred at this timestamp from this principal.' },
  { name: 'MLflow', tier: 'Tier 3', status: 'active', lastSync: '30 min ago', records: 14, enriches: 'Change Control records', proves: 'This model version was produced by this training run, approved through this evaluation.' },
  { name: 'Jira', tier: 'Tier 2', status: 'active', lastSync: '5 min ago', records: 0, enriches: 'Incident records', proves: 'The incident remediation followed a tracked, auditable process.' },
];

export const agentProofChainStatus = [
  { agentId: 'classifier-agent-01', grade: 'AUDIT-GRADE', cerExists: true, cssExists: true },
  { agentId: 'legal-draft-agent-02', grade: 'OPERATIONS-GRADE', cerExists: true, cssExists: true },
  { agentId: 'academy-recommender-01', grade: 'AUDIT-GRADE', cerExists: true, cssExists: true },
  { agentId: 'doc-processor-03', grade: 'UNAUDITED', cerExists: false, cssExists: false },
  { agentId: 'metadata-tagger-01', grade: 'AUDIT-GRADE', cerExists: true, cssExists: true },
  { agentId: 'audit-assistant-01', grade: 'AUDIT-GRADE', cerExists: true, cssExists: true },
];

export const chainIntegrityTimeline = [
  { date: 'Apr 17, 2026 · 09:00 UTC', status: 'ok', title: 'Evidence package regenerated', detail: 'PKG-2026-Q1-003 · Proof chain fully restored · All 5 nodes verified' },
  { date: 'Apr 16, 2026 · 14:30 UTC', status: 'ok', title: 'Control gap remediated', detail: 'External Legal Corpus re-verified · Control state restored · Evidence coverage: 94%' },
  { date: 'Apr 16, 2026 · 09:15 UTC', status: 'ok', title: 'Oversight evidence enriched', detail: 'Entra ID sync completed · Reviewer identity re-verified · CA-4471 certification confirmed' },
  { date: 'Apr 15, 2026 · 14:31 UTC', status: 'warn', title: 'Control gap introduced', detail: 'External Legal Corpus outside allowlist at decision time · Chain broken at CSS node · 143 decisions affected' },
  { date: 'Apr 14, 2026 · 23:00 UTC', status: 'ok', title: 'Chain integrity check passed', detail: 'All nodes verified · No gaps detected' },
  { date: 'Apr 14, 2026 · 09:00 UTC', status: 'ok', title: 'Oversight evidence enriched', detail: 'Entra ID corroboration added · Reconstruction method upgraded' },
  { date: 'Apr 12, 2026 · 11:00 UTC', status: 'ok', title: 'Control state corroborated', detail: 'ServiceNow GRC confirmed policy v2.3 independently' },
];

export const workflowProofChains = [
  { id: 'legal-doc', name: 'Legal Document Drafting Pipeline', grade: 'OPERATIONS-GRADE', scenario: 'broken' },
  { id: 'contract-class', name: 'Contract Classification Pipeline', grade: 'AUDIT-GRADE', scenario: 'clean' },
  { id: 'claims-proc', name: 'Claims Document Processing', grade: 'UNAUDITED', scenario: 'unaudited' },
  { id: 'academy-rec', name: 'Academy Training Recommendations', grade: 'AUDIT-GRADE', scenario: 'clean' },
  { id: 'webcast-meta', name: 'Webcast Metadata Tagging', grade: 'AUDIT-GRADE', scenario: 'clean' },
];


